import { Dispatch, SetStateAction, useEffect } from 'react';
import { recuperarIdentidadesGenero, recuperarLabelIdentidadeGenero } from '..';
import { UseFormSetValue } from 'react-hook-form';

export default function useSelectIdentidadeGeneroHook({
  setValue,
  opcoesIdentidadeGenero,
  identidadeGeneroSelecionada,
  setOpcoesIdentidadeGenero,
}: {
  // @ts-expect-error Valor Generico
  // eslint-disable-next-line no-undef
  setValue: UseFormSetValue<T>;
  opcoesIdentidadeGenero: Array<{ id: string; label: string }>;
  identidadeGeneroSelecionada: string;
  setOpcoesIdentidadeGenero: Dispatch<
    SetStateAction<
      Array<{
        id: string;
        label: string;
      }>
    >
  >;
}) {
  useEffect(() => {
    if (opcoesIdentidadeGenero?.length) return;

    recuperarIdentidadesGenero({
      setOpcoesIdentidadeGenero,
    });

    const handleVisibilityChange = () => {
      if (opcoesIdentidadeGenero?.length) return;

      if (document.visibilityState === 'visible') {
        recuperarIdentidadesGenero({
          setOpcoesIdentidadeGenero,
        });
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!identidadeGeneroSelecionada) return;
    const generoSelecionado = recuperarLabelIdentidadeGenero({
      identidadeGeneroSelecionada,
      opcoesIdentidadeGenero,
    });
    setValue('tipoGeneroID', generoSelecionado?.label ?? '', {
      shouldValidate: true,
      shouldDirty: true,
    });
  }, [identidadeGeneroSelecionada, opcoesIdentidadeGenero, setValue]);
}
